var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backTop"},[_c('div',{staticClass:"backTop-con",class:[_vm.active && 'active'],on:{"click":_vm.slideToTop}},[_vm._v("顶部")])])
}
var staticRenderFns = []

export { render, staticRenderFns }